export default {
    "sms": "SMS",
    "app": "App",
    "message": "Message",
    "notification": "Notification",
    "message type": "Message type",
    "notification name": "Notification name",
    "save analytics": "Save analytics",
    "failed list": "Failed list",
    "answer": "Answer",
    "compliance": "Compliance",
    "scoring": "Scoring",
    "failed answers": "Failed answers",
    "alerts": "Alerts",
    "select teams": "Select teams",
    "monitoring": "Monitoring",
    "delete shceduled email delivery": "Delete shceduled email delivery",
    'year': "Year",
    "repeat evey": "Repeat evey",
    "start date": "Start date",
    "report schedule delivery settings": "Report schedule delivery settings",
    "scheduled email delivery": "Scheduled email delivery",
    "authorizations": "Authorizations",
    "due": "due",
    "to do": "to do",
    "Celery": "Celery",
    "Crustaceans": "Crustaceans",
    "Eggs": "Eggs",
    "Fish": "Fish",
    "Gluten": "Gluten",
    "Lupin": "Lupin",
    "Milk": "Milk",
    "Molluscs": "Molluscs",
    "Mustard": "Mustard",
    "Nuts": "Nuts",
    "Peanuts": "Peanuts",
    "Sesame seeds": "Sesame seeds",
    "Soy": "Soy",
    "Sulphur dioxide": "Sulphur dioxide",
    "Don't have an account": "Don't have an account",
    "Log in to Qualizy": "Log in to Qualizy",
    "Or connect with": "Or connect with",
    "Digit code": "Digit code",
    "Google account": "Google account",
    "Business owner": "Business owner",
    "Manager/director": "Manager/director",
    "Quality or food safety manager": "Quality or food safety manager",
    "You don’t have any food items yet": "You don’t have any food items yet",
    "would you like to create one": "would you like to create one",
    "You don’t have any tasks scheduled yet": "You don’t have any tasks scheduled yet",
    "You don’t have any active template yet": "You don’t have any active template yet",
    "industry": "Industry",
    "skip": "Skip",
    "apply": "Apply",
    "Get Qualizy app on the phone": "Get Qualizy app on the phone",
    "step": "Step",
    "create account": "Create account",
    "company details": "Company details",
    "get link to the app": "Get link to the app",
    "schedule a free set-up call": "Schedule a free set-up call",
    "already have an account": "Already have an account",
    "first name and last name": "First name and Last name",
    "I accept the terms & condition": "I accept the terms & condition",
    "Tell us about your company so that we could customize your experience": "Tell us about your company so that we could customize your experience",
    "company name": "Company name",
    "type of company": "Type of company",
    "Restaurant": "Restaurant",  // begin industry tag
    "Butchery": "Butchery",
    "Food production": "Food production",
    "Coffee": "Coffee",
    "Hotel": "Hotel",
    "Catering": "Catering",
    "Food retail": "Food retail",
    "Collectivity": "Collectivity",
    "Bakery": "Bakery",
    "Other": "Other", // end industry tag
    "Number of employees": "Number of employees",
    "peoples": "Peoples",
    "more peoples": "more Peoples",
    "We will send you a link to download Qualizy app": "We will send you a link to download Qualizy app",
    "Grab a time here with an expert for a FREE set-up call": "Grab a time here with an expert for a FREE set-up call",
    "Rather than spending hours trying out our software and reading documentation, We invite you to spend 30 minutes with our experts getting specific answers to your questions and having a true expert help you customise the product to your specific needs & workflow": "Rather than spending hours trying out our software and reading documentation, We invite you to spend 30 minutes with our experts getting specific answers to your questions and having a true expert help you customise the product to your specific needs & workflow",
    "finish": "Finish",
    "resend invite": "Resend invite",
    "update article": "Update article",
    "Yes": "Yes",
    "No": "No",
    "N/A": "N/A",
    "non compliant": "Non compliant",
    "compliant": "Compliant",
    "Correct": "Correct",
    "Not correct": "Not correct",
    "poor": "Poor",
    "fair": "Fair",
    "good": "Good",
    "pass": "Pass",
    "fail": "Fail",
    "visible to": "Visible to",
    "report title": "Report title",
    "undo": "Undo",
    "clear": "Clear",
    "signature": "Signature",
    "please type 3 letters at least": "Please type 3 letters at least.",
    "more details": "More details",
    "cell auto width": "Cell auto width",
    "every": "Every",
    "page": "page",
    "of": "of",
    "tasks for": "tasks for",
    "available": "Available",
    "receive email": "Receive email",
    "language": "Language",
    "no data available": " No data available",
    "the pin number is aleady exist": "This PIN aleady exists!",
    "facebook": "Facebook",
    "linkedin": "Linkedin",
    "twitter": "Twitter",
    "edit profile": "Edit profile",
    "timezone": "Timezone",
    "unique pin number": "Unique PIN number",
    "you are about to delete team": "You are about to delete a team",
    "this will delete your team": "This will delete your team",
    "yes, delete team": "Yes, delete team",
    "update team": "Update team",
    "cancel, keep team": "Cancel, keep team",
    "the team is already exist !": "The team is already exists !",
    "add team": "Add team",
    "team name": "Team name",
    "teammates": "Teammates",
    "social media": "Social media",
    "add excel file": "Add Excel file",
    "or drop file here": "or drop file here",
    "invites will be sent to the following emails:": "Invites will be sent to the following Emails:",
    "invite users": "Invite users",
    "last login": "Last login",
    "user management": "User Management",
    "completed on time": "Completed on time",
    "select the options from right side bar to generate the report.": "Select the options from right side bar to generate the report.",
    "check list": "Check List",
    "you have no authorization for this page. please contact your admin.": "You don't have the authorisation for this page. Please contact your admin.",
    "you are not authorized": "You are not authorised",
    "cancel, keep location": "Cancel, Keep location",
    "yes, delete location": "Yes, Delete location",
    "you are about to delete location": "You are about to delete location",
    "edit location": "Edit location",
    "area": "Area",
    "region": "Region",
    "new location": "New location",
    "add location": "Add location",
    "or drop PDF here": " or drop PDF here",
    "add pdf": "Add PDF",
    "view article": "View article",
    "cancel, keep category": "Cancel, Keep category",
    "yes, delete category": "Yes, Delete category",
    "you are about to delete category": "You are about to delete category",
    "this will delete your category": "This will delete your category",
    "you are about to delete schedule": "You are about to delete schedule",
    "update category": "Update category",
    "cancel, keep schedule": "Cancel, keep schedule",
    "yes, delete schedule": "Yes, delete schedule",
    "this will delete your schedule": "This will delete your schedule",
    "active": "Active",
    "select tags": "Select tags",
    "order template": "Order template",
    "popular templates": "Popular templates",
    "cancel, keep templete": "Cancel, keep templete",
    "yes, delete templete": "Yes, delete templete",
    "this will delete your": "This will delete your",
    "you are about to delete template": "You are about to delete template",
    "This template will be deleted completely.Are you sure ?": "This template will be deleted completely. Are you sure ?",
    "duplicate template": "Duplicate template",
    "update template": "Update Template",
    "preview": "Preview",
    "add page": "Add Page",
    "default": "Default",
    "equal": "Equal",
    "not equal": "Not equal",
    "less than": "Less than",
    "less than or equal": "Less than or equal",
    "greater than": "Greater than",
    "greater than or equal": "Greater than or equal",
    "between": "Between",
    "add section": "Add Section",
    "duplicate section": "Duplicate Section",
    "delete section": "Delete Section",
    "add question": "Add Question",
    "add score": "Add Score",
    "add action": "Add Action",
    "required": "Required",
    "unit": "Unit",
    "date & time": "Date & Time",
    "write instructions": "Write instructions",
    "section title": "Section title",
    "select type of response": "Select type of response",
    "save & apply": "Save & Apply",
    "e.g.Yes,No,N/A": "e.g. Yes, No, N/A",
    "add response": "Add response",
    "new closed answer": "New closed answer",
    "edit closed answer": "Edit closed answer",
    "add new": "Add new",
    "question name": "Question name",
    "type of response": "Type of response",
    "question": "Question",
    "create": "Create",
    "add new tag": "Add new tag",
    "select location": "Select location",
    "create a template": "Create a template",
    "create template": "Create template",
    "template name": "Template name",
    "add new template": "Add new template",
    "duplicate food item": "Duplicate food item",
    "food items to be added": "Food items to be added",
    "tags": "Tags",
    "delete question": "Delete question",
    "added ingredients": "Added ingredients",
    "add ingredient": "Add ingredient",
    "ingredient": "Ingredient",
    "bulk upload": "Bulk upload",
    "in process": "incompleted",
    "you are about to delete": "You are about to delete",
    "are you sure to delete ?": "Are you sure to delete ?",
    "update food item": "Update food item",
    "edit food item": "Edit food item",
    "expire": "Expire",
    "note": "Note",
    "expiry date": "Expiry date",
    "add more info": "Add more info",
    "unit of measure": "Unit of measure",
    "the supplier is already exist !": "The supplier already exists !",
    "the food item is already exist !": "The food item already exists !",
    "this food item is already exist in this file !": "This food item already exists.",
    "this field is required !": "This field is required !",
    "supplier name": "Supplier name",
    "add new supplier": "Add new supplier",
    "delivered": "Delivered",
    "prepared": "Prepared",
    "select": "Select",
    "chat": "Chat",
    "choose the type": "Choose the type",
    "no due date": "No due date",
    "in progress": "In progress",
    "task details": "Task details",
    "supplier": "Supplier",
    "clear filters": "Clear Filters",
    "apply filters": "Apply Filters",
    "removed": "Removed",
    "faild": "Failed",
    "passed": "Passed",
    "share": "Share",
    "team": "Team",
    "public": "Public",
    "Just me": "Just me",
    "Update Report": "Update Report",
    "update": "Update",
    "export": "Export",
    "Share Report": "Share Report",
    "edit": "Edit",
    "history": "History",
    "process": "Process",
    "unset": "Unset",
    "quantity": "Quantity",
    "unscheduled": "Unscheduled",
    "more than day ago": "More than day ago",
    "more than week ago": "More than week ago",
    "last loged in": "Last loged in",
    "due date": "Due date",
    "workers": "Workers",
    "filters": "Filters",
    "add task": "Add Task",
    "no location": "No Location",
    "day": "Day",
    "week": "Week",
    "month": "Month",
    "Create Report": "Create Report",
    "New Report": "New Report",
    "today": "Today",
    "this week": "This Week",
    "this month": "This Month",
    "this quarter": "This Quarter",
    "this year": "This Year",
    "yesterday": "Yesterday",
    "previous week": "Previous Week",
    "previous month": "Previous Month",
    "previous quarter": "Previous Quarter",
    "previous year": "Previous Year",
    "all time": "All Time",
    "custom": "Custom",
    "day(s)": "Day(s)",
    "month(s)": "Month(s)",
    "week(s)": "Week(s)",
    "Add a new Answers": "Add a new Answers",
    "Question Title": "Question Title",
    "Last updated on": "Last updated on",
    "category": "category",
    "change": "change",
    "Edit Category for knowledge base": "Edit Category for knowledge base",
    "company": "company",
    "confirm password": "Confirm password",
    "Select a File": "Select a File",
    "Desactivate this location": "Desactivate this location",
    "address": "address",
    "Assign Users": "Assign Users",
    "desactivate this team": "Desactivate this team",
    "group": "group",
    "group name": "group name",
    "user name": "User name",
    "Select the location": "Select the location",
    "Never connected": "Never connected",
    "Invite your coworkers to join you": "Invite your coworkers to join you",
    "Add new a user": "Add new a user",
    "edit user": "edit user",
    "last vist": "last vist",
    "item": "item",
    "Completed Tasks": "Completed Tasks",
    "congratulations": "congratulations",
    "You have completed": "You have completed",
    "of your task today": "of your task today",
    "You have no any task today": "You have no any task today",
    "Check your new badge in your profile": "Check your new badge in your profile",
    "print": "Print",
    "Create a new Schedule": "Create a new Schedule",
    "Update Schedule": "Update Schedule",
    "Schedule available from": "Schedule available from",
    "new schedule": "New schedule",
    "this box if you want to schedule this template later": "this box if you want to schedule this template later",
    "Please select a repeat rule": "Please select a repeat rule",
    "Select Assign Group": "Select Assign Group",
    "Please select the teams": "Please select the teams",
    "duplicate question": "Duplicate question",
    "delete page": "Delete page",
    "Back to Tempates": "Back to Tempates",
    "trash": "trash",
    "Select template": "Select template",
    "expired": "Expired",
    "forever": "N/A",
    "prev": "prev",
    "dashboard": "dashboard",
    "My Tasks": "My Tasks",
    "my tasks": "my tasks",
    "Search": "Search",
    "status": "Status",
    "due tasks": "Due tasks",
    "overdue": "Overdue",
    "completed": "Completed",
    "labels": "Labels",
    "bookmarked": "bookmarked",
    "view logs": "view logs",
    "log entry": "log entry",
    "incomplete": "incomplete",
    "complete": "complete",
    "delete": "Delete",
    "Loged in": "Loged in",
    "days ago": "days ago",
    "day ago": "day ago",
    "food items": "Food items",
    "Food Items": "Food Items",
    "descriptions": "Descriptions",
    "batch number": "Batch number",
    "batch": "Batch",
    "cancel": "Cancel",
    "save": "Save",
    "no expiry date": "no expiry date",
    "discarded": "discarded",
    "allergens": "Allergens",
    "expire in": "Expire in",
    "all": "All",
    "add food item": "Add food item",
    "food item name": "Food item name",
    "clear filter": "clear filter",
    "no expiry": "No expiry",
    "by": "by",
    "created": "Created",
    "expiry": "Expiry",
    "discard": "discard",
    "print label": "print label",
    "event": "event",
    "new event": "new event",
    "preparation date": "preparation date",
    "expiry date": "Expiry date",
    "created for": "created for",
    "templates": "Templates",
    "new template": "new template",
    "scheduled": "Scheduled",
    "important": "important",
    "trashed": "trashed",
    "select all": "select all",
    "blank template": "Blank template",
    "header": "header",
    "content": "content",
    "location": "Location",
    "Untitled Template": "Untitled Template",
    "add comment": "add comment",
    "+ Add comment": "Add comment",
    "no selected": "no selected",
    "select image": "Select image",
    "add a new tag": "add a new tag",
    "schedule this template": "schedule this template",
    "next": "Next",
    "back": "Back",
    "Page Title": "Page Title",
    "Unnamed": "Unnamed",
    "none": "none",
    "add a new page": "add a new page",
    "add a new question": "add a new question",
    "duplicate page": "Duplicate page",
    "duplicate": "Duplicate",
    "add answer": "add answer",
    "back to template": "back to template",
    "type": "type",
    "Select Type": "Select Type",
    "opened answers": "opened answers",
    "number": "number",
    "date": "Date",
    "instruction": "instruction",
    "date time": "Date Time",
    "time": "Time",
    "checkbox": "checkbox",
    "drop down": "drop down",
    "example: apple,orange": "example: apple,orange",
    "the value will be separated by comma.": "the value will be separated by comma.",
    "paragraph": "paragraph",
    "short answer": "short answer",
    "temperature": "Temperature",
    "mac address": "Mac address",
    "calculation fields": "calculation fields",
    "star": "star",
    "score": "Score",
    "general score": "General Score",
    "closed answers": "closed answers",
    "failed response": "Failed response",
    "smart fields": "smart fields",
    "teams": "Teams",
    "automatic date and time stamp": "automatic date and time stamp",
    "items": "items",
    "automatic user stamp": "automatic user stamp",
    "users": "Users",
    "attachments": "attachments",
    "photo": "photo",
    "receipts": "receipts",
    "action": "Action",
    "if answer is": "If answer is",
    "send a notification to": "Send a notification to",
    "notification type": "Notification type",
    "success": "success",
    "danger": "danger",
    "warning": "warning",
    "dark": "dark",
    "condition": "condition",
    "value": "value",
    "assignees": "assignees",
    "select assign group": "select assign group",
    "due time": "due time",
    "add due time": "add due time",
    "save schedule": "save schedule",
    "uncheck": "uncheck",
    "this box if you want to schedule this template later.": "Thick this box if you want to schedule this template later.",
    "frequency": "Frequency",
    "repeat rule": "Repeat rule",
    "repeat days": "repeat days",
    "No Repeat": "No Repeat",
    "Daily": "Daily",
    "Monthly": "Monthly",
    "Weekly": "Weekly",
    "schedule": "Schedule",
    "report": "report",
    "reports": "reports",
    "from": "from",
    "to": "to",
    "label": "label",
    "template": "template",
    "select filter": "select filter",
    "analytics": "analytics",
    "congratualations": "congratualations",
    "you have complated of your task today": "You have completed all your tasks today",
    "check your new badge in your profile": "check your new badge in your profile",
    "most common overdue tasks": "most common overdue tasks",
    "duration": "duration",
    "task tracker": "task tracker",
    "tasks": "Tasks",
    "task completed": "task completed",
    "overdue tasks": "Overdue tasks",
    "template usage": "template usage",
    "system settings": "system settings",
    "users management": "Users management",
    "add user": "Add user",
    "name": "Name",
    "email": "Email",
    "job title": "Job title",
    "phone": "Phone",
    "role": "Role",
    "last visit": "last visit",
    "auditor": "Auditor",
    "super admin": "Super admin",
    "admin": "Admin",
    "supervisor": "Supervisor",
    "operator": "Operator",
    "desactivate this user": "desactivate this user",
    "groups": "groups",
    "Add new a group": "Add new a group",
    "active users": "active users",
    "send message": "send message",
    "The more people you invite, the better the collaboration gets. You can invite anyone fron your company.": "The more people you invite, the better the collaboration gets. You can invite anyone fron your company.",
    "invite": "invite",
    "Import CSV": "Import CSV",
    "locations": "Locations",
    "Add new a location": "Add new a location",
    "settings": "settings",
    "my profile": "my profile",
    "phone number": "Phone number",
    "done": "Done",
    "change password": "Change password",
    "document": "Document",
    "title": "Title",
    "attachment": "attachment",
    "add a new document": "add a new document",
    "company profile": "company profile",
    "company address": "company address",
    "company phone number": "company phone number",
    "company bussiness": "company bussiness",
    "knowledge base": "Knowledge base",
    "knowledgeBase": "KnowledgeBase",
    "add category": "Add category",
    "Add category for knowledge base": "Add category for knowledge base",
    "Category name": "Category name",
    "Category image": "Category image",
    "categories": "categories",
    "Add a new article": "Add a new article",
    "create a new article": "Create a new article",
    "select category": "select category",
    "Select a PDF": "Select a PDF",
    "articles": "Articles",
    "How can we help": "How can we help",
    "We have some instruction for you. You can reference them right now.": "Find the informations you need in a blink of an eye",
    "contacts": "contacts",
    "profile": "profile",
    "logout": "logout",
    "support": "support",
    "sign in": "Sign in",
    "sign up": "Sign up",
    "login": "Login",
    "password": "Password",
    "remember me": "Remember me",
    "forgot password": "Forgot password",
    "digit": "Digit",
    "or": "Or",
    "welcome to back, please login your account.": "Welcome to back, please login to your account.",
    "login with digit code": "login with digit code",
    "digit code": "digit code",
    "view template": "view template",
    "use template": "use template",
    "template details": "template details",
    "Monday": "Monday",
    "Tuesday": "Tuesday",
    "Wednesday": "Wednesday",
    "Thursday": "Thursday",
    "Friday": "Friday",
    "Saturday": "Saturday",
    "SunDay": "Sunday",
    "save_as": "Save as",
    "save_report": "Save report",
    "report_name": "Report name",
    "me": "Me (private)",
    "text": "Text",
    "delivery_schedule": "Delivery Schedule",
    "create_schedule": "Create custom schedule to receive regular reports via email.",
    "clean_all": "Clean all",
    "failed_non_failed": "Failed / Non failed",
    "least_loc": "Least performing location",
    "least_team": "Least performing team",
    "select_options": "Select the options from right side bar to generate the analytics.",
    "compliance_per_templates": "Compliance per templates",
    "compliance_per_locations": "Compliance per locations",
    "overdue_tasks": "Overdue tasks out of total",
    "high_overdue_tasks_loc": "High overdue tasks per location",
    "high_overdue_tasks_team": "Team with most overdue tasks",
    "overdue_tasks_per_loc": "Overdue tasks per location",
    "overdue_tasks_by_time": "Overdue tasks by time",
    "overdue_tasks_by_loc": "Overdue tasks by locations",
    "overdue_tasks_by_templates": "Overdue tasks by templates",
    "overdue_tasks_list": "List of overdue tasks",
    "high_failure_answers_loc": "High failure answers location",
    "least_performing_team": "Least performing team",
    "failed_answers_by_loc": "Failed answers by location",
    "failed_answers_by_time": "Failed answers by time",
    "no_data": "No data",
    "number_of_alerts": "Number of alerts received",
    "most_alerts_loc": "Location with biggest number of alerts",
    "most_alerts_team": "Team with biggest number of alerts",
    "alerts_log": "Alerts log",
    "Watch this video to see how it works": "Watch this video to see how it works",


    "Upload your own images": "Upload your own images",
    "Upload": "Upload",
    "Uploading": "Uploading",

    "payments": "payments",
    "Billing Details": "Billing Details",
    "Add billing details": "Add billing details",
    "You reached the limit of free logs. Provide billing details to continue using the system.": "You reached the limit of free logs. Provide billing details to continue using the system.",
    "Current logs usage per month": "Current logs usage per month",
    "You need to log another 156 logs to reach a cheaper pricing plan.": "You need to log another 156 logs to reach a cheaper pricing plan.",
    "You need to log another": "You need to log another ",
    "logs to reach a cheaper pricing plan.": " logs to reach a cheaper pricing plan. ",
    "Accrued amount to be paid this month:": "Accrued amount to be paid this month:",
    "Free": "Free",
    "logs": "logs",
    "Billing history": "Billing history",
    "Qualizy pricing is based on task logs...": "Qualizy pricing is based on task logs. A log is a line of completed data in a checklist. Empty answers don’t count. For example, HACCP audit with 78 questions, and 72 answers and 7 empty answer will account for 72 log credit. And the more you log, the cheaper price per log is applied to all log credits for a given month.",
    "Invite your friends to use Qualizy and get 150 FREE logs each time": "Invite your friends to use Qualizy and get 150 FREE logs each time",
    "This referral program resets every month.": "This referral program resets every month.",
    "Invite another professional": "Invite another professional",
    "You have no billing history yet": "You have no billing history yet",
    "Estimate how much you are currently saving by using Qualizy": "Estimate how much you are currently saving by using Qualizy",
    "What is your average employee salary?": "What is your average employee salary?",
    "an hour": "an hour",
    "How many people do you have on your team?": "How many people do you have on your team?",
    "employees": "employees",
    "How many fridges/freezers does your business have?": "How many fridges/freezers does your business have?",
    "units": "units",
    "Your forecasted expenses using pen and paper": "Your forecasted expenses using pen and paper",
    "Expenses on Qualizy": "Expenses on Qualizy",
    "Current saving": "Current saving",
    "about_estimate": `This estimate is based on the informations you have provided and an average time spent creating a record using Pen & Paper of 1:30 min per record and an average of 7 recording points per employees per day (Temp logs, cleaning logs, delivery logs, food labelling etc..)`,
    "Add your Billing Detail": "Add your Billing Detail",
    "Loading...": "Loading...",
    "Manage billing details": "Manage billing details",
    "date_used": 'Date used',
    "tasks_type": "Tasks type",
    "total_tasks": "Total tasks",
    "failed_tasks": "Failed tasks",
    "Billing": "Billing",
    "Upgrade Plan": "Upgrade Plan",
    "Count of logs you used: ": "Count of logs you used: ",
    "Accrued log count: ": "Accrued log count: ",
    "Help us set-up the right food safety program for your company": "Help us set-up the right food safety program for your company",
    "What is the name of your company?": "What is the name of your company?",
    "What describes the best your operation? This will help us deploy the perfect templates for you.": "What describes the best your operation? This will help us deploy the perfect templates for you.",
    "What is your job title?": "What is your job title?",
    "How many locations does your company have?": "How many locations does your company have?",
    "Sensors": "Sensors",
    "Buy temperature sensors": "Buy temperature sensors",
    "Refer & earn": "Refer & earn",
    "Subscribe to continue": "Subscribe to continue",
    "Upgrade to pro": "Upgrade to pro",
}